
import React from "react";
import SearchBar from "./SearchBar";
import { Bell, User, Menu } from "lucide-react";
import { mockStatistics } from "@/data/mockData";

interface DashboardHeaderProps {
  onMenuToggle?: () => void;
  onSearch?: (query: string) => void;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({ 
  onMenuToggle, 
  onSearch 
}) => {
  return (
    <header className="bg-background border-b border-border mb-6">
      <div className="container px-4 py-4 mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <div className="flex items-center">
            <button 
              onClick={onMenuToggle}
              className="p-2 mr-4 rounded-lg hover:bg-muted transition-colors md:hidden"
            >
              <Menu className="w-5 h-5" />
            </button>
            <div>
              <h1 className="text-2xl font-bold text-foreground">Shall we crush?</h1>
              <p className="text-sm text-muted-foreground">
                Manage your podcasts, guests, and content
              </p>
            </div>
          </div>
          
          <div className="flex items-center gap-3 w-full md:w-auto">
            <SearchBar 
              onSearch={onSearch} 
              className="flex-grow md:w-80" 
            />
            <button className="p-2 rounded-lg hover:bg-muted transition-colors relative">
              <Bell className="w-5 h-5" />
              <span className="absolute top-1 right-1 w-2 h-2 bg-primary rounded-full" />
            </button>
            <button className="p-2 rounded-lg hover:bg-muted transition-colors">
              <User className="w-5 h-5" />
            </button>
          </div>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6 animate-slide-up">
          <StatCard 
            label="Total Guests" 
            value={mockStatistics.totalGuests.toString()} 
          />
          <StatCard 
            label="Upcoming Episodes" 
            value={mockStatistics.upcomingEpisodes.toString()} 
          />
          <StatCard 
            label="Published Episodes" 
            value={mockStatistics.publishedEpisodes.toString()} 
          />
          <StatCard 
            label="Avg. Listens/Episode" 
            value={mockStatistics.reachStats.avgListensPerEpisode.toLocaleString()} 
            trend={`+${mockStatistics.reachStats.growth}%`}
            trendUp
          />
        </div>
      </div>
    </header>
  );
};

interface StatCardProps {
  label: string;
  value: string;
  trend?: string;
  trendUp?: boolean;
}

const StatCard: React.FC<StatCardProps> = ({ label, value, trend, trendUp }) => {
  return (
    <div className="bg-card rounded-lg p-4 shadow-subtle border border-border/40">
      <h4 className="text-sm font-medium text-muted-foreground mb-1">{label}</h4>
      <div className="flex items-baseline">
        <span className="text-2xl font-bold text-foreground">{value}</span>
        {trend && (
          <span className={`ml-2 text-xs font-medium ${trendUp ? 'text-status-scheduled' : 'text-status-pending'}`}>
            {trend}
          </span>
        )}
      </div>
    </div>
  );
};

export default DashboardHeader;
